<template>
  <div>
    <h1 class="my-5" v-html="title" />

    <b-row class="mb-5">
      <b-col cols="auto">
        <img :src="assistant.src" :alt="assistant.alt" class="mr-3" />
      </b-col>

      <b-col>
				<div class="bg-light p-3 rounded">
					<p>Bonjour, je suis Julie, votre conseillère {{ appName }}.</p>
					<p>Pour commencer, merci d'indiquer les informations liées à votre entreprise.</p>
				</div>
			</b-col>
    </b-row>

    <b-form class="mb-5">
      <b-form-row class="mb-5">
        <b-col>
          <label class="h4"><b>Forme juridique</b> de l'entreprise</label>

          <b-form-group invalid-feedback="Le type de l'entreprise est obligatoire">
            <b-form-radio-group
            v-model="company.legalForm"
            :options="legalForms"
            stacked
            buttons
            button-variant="outline-primary"
            size="lg"
						@change="legalFormChange($event)" />
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row class="mb-5">
        <b-col cols="12" md="6" class="mb-4">
					<label for="company-name" class="h4"><b>Nom</b> de l'entreprise</label>

          <b-form-group invalid-feedback="Le nom de l'entreprise est obligatoire">
            <b-input
            id="company-name"
            v-model.trim="$v.company.name.$model"
            :state="validateState($v.company.name)" />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" class="mb-4">
          <label for="company-activity" class="h4"><b>Activité</b> de l'entreprise</label>

          <b-form-group invalid-feedback="L'activité de l'entreprise est obligatoire">
            <b-input
            id="company-activity"
            v-model.trim="$v.company.activity.$model"
            :state="validateState($v.company.activity)" />
          </b-form-group>
        </b-col>
      </b-form-row>

			<!-- Siège Social -->
			<b-form-group class="mb-5">
				<b-form-row class="mb-4">
					<b-col>
						<label class="h4">Choix du <b>Siège Social</b></label>

						<br />

						<b-form-radio-group
						v-model="company.headOffice.location"
						:options="headOffice.locations"
						@change="addDomiciliationFees($event)"
						buttons
						button-variant="outline-primary"
						stacked
						size="lg" />
					</b-col>
				</b-form-row>

				<b-form-group v-if="company.headOffice.location === 'Domiciliation via Assistel'">
					<label for="company-head-office-address-name" class="h4"><b>Adresse</b> Assistel</label>

					<b-form-row>
						<b-col cols="12" md="6">
							<b-form-group invalid-feedback="L'adresse du Siège Social est obligatoire">
								<b-form-select
								id="company-head-office-address-name"
								v-model="company.headOffice.address.name"
								:options="this.getDomiciliationAddresses"
								:state="validateState($v.company.headOffice.address.name)" />
							</b-form-group>
						</b-col>
					</b-form-row>
				</b-form-group>

				<b-form-group v-else>
					<label class="h4"><b>Adresse</b> du siège</label>

					<b-form-row>
						<b-col cols="12" md="6" class="mb-3 mb-md-0">
							<b-form-group label="Adresse" label-for="company-address" invalid-feedback="L'adresse du Siège Social est obligatoire">
								<b-input
								id="company-address"
								v-model.trim="$v.company.headOffice.address.place.$model"
								:state="validateState($v.company.headOffice.address.place)" />
							</b-form-group>
						</b-col>

						<b-col cols="12" md="2" class="mb-3 mb-md-0">
							<b-form-group
							label="Code postal"
							label-for="company-zip-code"
							invalid-feedback="Le code postal du Siège Social est obligatoire, doit être au format numérique et comporter 5 chiffres.">
								<b-input
								id="company-zip-code"
								v-model.trim="$v.company.headOffice.address.zipCode.$model"
								:state="validateState($v.company.headOffice.address.zipCode)"
								@change="getCitiesByZipCode" />
							</b-form-group>
						</b-col>

						<b-col cols="12" md="4">
							<b-form-group label="Ville" label-for="company-city" invalid-feedback="La ville du Siège Social est obligatoire">
								<b-input
								id="company-city"
								list="citiesList"
								v-model.trim="$v.company.headOffice.address.city.$model"
								:state="validateState($v.company.headOffice.address.city)" />

								<b-datalist id="citiesList" :options="citiesList" />
							</b-form-group>
						</b-col>
					</b-form-row>
				</b-form-group>
			</b-form-group>

			<!-- Objet social -->
			<b-form-row class="mb-5">
				<b-col>
					<label class="h4" for="social-object"><b>Objet social</b></label>

					<b-form-group invalid-feedback="L'objet social est obligatoire">
						<b-form-textarea
						id="social-object"
						v-model.trim="$v.company.socialObject.$model"
						:state="validateState($v.company.socialObject)"
						placeholder="Veuillez décrire l'objet social de la société" />
					</b-form-group>
				</b-col>
			</b-form-row>

			<!-- Capital social -->
			<b-form-group class="mb-5">
				<label class="h4">Le <b>Capital Social</b></label>

				<b-form-row class="mb-4">
					<b-col cols="12" md="6">
						<b-form-group label="Capital fixe ou variable">
							<b-form-radio-group
							v-model="company.shareCapital.type"
							buttons
							button-variant="outline-primary">
								<b-form-radio value="Fixe">Fixe</b-form-radio>
								<b-form-radio value="Variable">Variable</b-form-radio>
							</b-form-radio-group>
						</b-form-group>
					</b-col>

					<b-col cols="12" md="6" v-if="company.legalForm === 'EURL / SARL' || company.legalForm === 'SAS' || company.legalForm === 'SASU'">
						<b-form-group label="Libération du capital">
							<b-form-radio-group
							v-model="company.shareCapital.liberation"
							buttons
							button-variant="outline-primary">
								<b-form-radio value="100% libéré">100% libéré</b-form-radio>
								<b-form-radio v-if="company.legalForm === 'EURL / SARL'" value="20% libéré">20% libéré</b-form-radio>
								<b-form-radio value="50% libéré" v-if="company.legalForm === 'SAS' || company.legalForm === 'SASU'">50% libéré</b-form-radio>
							</b-form-radio-group>
						</b-form-group>
					</b-col>
				</b-form-row>

				<b-form-row>
					<b-col>
						<b-form-group>
							<h2 class="h4"><b>Dépot</b> du Capital Social</h2>

							<b-form-radio-group
							v-model="company.shareCapital.deposit.location"
							:options="shareCapitalDeposits"
							buttons
							stacked
							button-variant="outline-primary"
							size="lg" />
						</b-form-group>
					</b-col>
				</b-form-row>
			</b-form-group>

			<!-- Banque -->
			<b-form-group class="mb-5" v-if="company.shareCapital.deposit.location === 'Dans une banque'">
				<b-form-row class="mb-4">
					<b-col cols="12" md="6">
						<label for="bank-name" class="h4"><b>Nom</b> de la banque</label>

						<b-form-group invalid-feedback="Le nom de la banque est obligatoire">
							<b-input-group prepend="🏦">
								<b-input
								id="bank-name"
								v-model.trim="$v.company.shareCapital.deposit.name.$model"
								:state="validateState($v.company.shareCapital.deposit.name)" />
							</b-input-group>
						</b-form-group>
					</b-col>
				</b-form-row>

				<b-form-group>
					<label class="h4"><b>Adresse</b> de la banque</label>

					<b-form-row>
						<b-col cols="12" md="6" class="mb-3 mb-md-0">
							<b-form-group label="Adresse" label-for="bank-address" invalid-feedback="L'adresse de la banque est obligatoire">
								<b-input
								id="bank-address"
								v-model.trim="$v.company.shareCapital.deposit.address.place.$model"
								:state="validateState($v.company.shareCapital.deposit.address.place)" />
							</b-form-group>
						</b-col>

						<b-col cols="12" md="2" class="mb-3 mb-md-0">
							<b-form-group
							label="Code postal"
							label-for="bank-zip-code"
							invalid-feedback="Le code postal de la banque est obligatoire, doit être au format numérique et comporter 5 chiffres.">
								<b-input
								id="bank-zip-code"
								v-model.trim="$v.company.shareCapital.deposit.address.zipCode.$model"
								:state="validateState($v.company.shareCapital.deposit.address.zipCode)"
								@change="getCitiesByZipCode" />
							</b-form-group>
						</b-col>

						<b-col cols="12" md="4">
							<b-form-group label="Ville" label-for="bank-city" invalid-feedback="La ville de la banque est obligatoire">
								<b-input
								id="bank-city"
								list="citiesList"
								v-model.trim="$v.company.shareCapital.deposit.address.city.$model"
								:state="validateState($v.company.shareCapital.deposit.address.city)" />

								<b-datalist id="citiesList" :options="citiesList" />
							</b-form-group>
						</b-col>
					</b-form-row>
				</b-form-group>
			</b-form-group>

			<!-- Etude notariale ou CDC -->
			<b-form-group class="mb-5" v-else>
				<b-form-row class="mb-4">
					<b-col cols="12" md="6">
						<label for="other-name" class="h4"><b>Nom</b> de l'étude notarial ou de la CDC</label>

						<b-form-group invalid-feedback="Le nom de l'étude notarial ou de la CDC est obligatoire">
							<b-input
							id="other-name"
							v-model.trim="$v.company.shareCapital.deposit.name.$model"
							:state="validateState($v.company.shareCapital.deposit.name)" />
						</b-form-group>
					</b-col>
				</b-form-row>

				<b-form-group>
					<label class="h4"><b>Adresse</b> de l'étude notarial ou de la CDC</label>

					<b-form-row>
						<b-col cols="12" md="6" class="mb-3 mb-md-0">
							<b-form-group label="Adresse" label-for="bank-address" invalid-feedback="L'adresse de l'étude notarial ou de la CDC est obligatoire">
								<b-input
								id="other-address"
								v-model.trim="$v.company.shareCapital.deposit.address.place.$model"
								:state="validateState($v.company.shareCapital.deposit.address.place)" />
							</b-form-group>
						</b-col>

						<b-col cols="12" md="2" class="mb-3 mb-md-0">
							<b-form-group
							label="Code postal"
							label-for="other-zip-code"
							invalid-feedback="Le code postal de l'étude notarial ou de la CDC est obligatoire, doit être au format numérique et comporter 5 chiffres.">
								<b-input
								id="other-zip-code"
								v-model.trim="$v.company.shareCapital.deposit.address.zipCode.$model"
								:state="validateState($v.company.shareCapital.deposit.address.zipCode)"
								@change="getCitiesByZipCode" />
							</b-form-group>
						</b-col>

						<b-col cols="12" md="4">
							<b-form-group label="Ville" label-for="other-city" invalid-feedback="La ville de l'étude notarial ou de la CDC est obligatoire">
								<b-input
								id="other-city"
								list="citiesList"
								v-model.trim="$v.company.shareCapital.deposit.address.city.$model"
								:state="validateState($v.company.shareCapital.deposit.address.city)" />

								<b-datalist id="citiesList" :options="citiesList" />
							</b-form-group>
						</b-col>
					</b-form-row>
				</b-form-group>
			</b-form-group>

			<!-- Exercice social -->
			<b-form-group class="mb-5">
				<label class="h4">L'<b>exercice</b> social</label>

				<b-form-row>
					<b-col cols="12" md="6" class="mb-4 mb-md-0">
						<b-form-group
						label="Date de clôture de l'exercice social"
						label-for="closing-fiscal-year"
						invalid-feedback="La date de cloture de l'exercice social est obligatoire">
							<b-form-select
							id="closing-fiscal-year"
							v-model="company.fiscalYear.closingDate"
							:options="fiscalYearEndDates"
							:state="validateState($v.company.fiscalYear.closingDate)"
							@change="setFirstFiscalYear" />
						</b-form-group>
					</b-col>

					<b-col cols="12" md="6">
						<b-form-group
						label="Le cas échéant, année de clôture du premier exercice social"
						label-for="closing-first-fiscal-year"
						invalid-feedback="L'année de clôture du premier exercice social est obligatoire">
							<b-form-select
							id="closing-first-fiscal-year"
							v-model="company.fiscalYear.closingDateOfFirst"
							:options="fiscalEndYears"
							:state="validateState($v.company.fiscalYear.closingDateOfFirst)" />
						</b-form-group>
					</b-col>
				</b-form-row>
			</b-form-group>

			<b-form-group class="mb-5">
				<label class="h4"><b>Distinction</b> commerciale</label>

				<b-form-row>
					<b-col cols="12" md="4" class="mb-4 mb-md-0">
						<b-form-checkbox
						v-model="company.commercialDistinction.acronym.active"
						button
						button-variant="primary"
						size="lg">
							Sigle
						</b-form-checkbox>

						<b-form-group invalid-feedback="Le sigle est obligatoire" class="mt-3" v-if="company.commercialDistinction.acronym.active">
							<b-input
							v-model.trim="$v.company.commercialDistinction.acronym.text.$model"
							:state="validateState($v.company.commercialDistinction.acronym.text)" />
						</b-form-group>
					</b-col>

					<b-col cols="12" md="4" class="mb-4 mb-md-0">
						<b-form-checkbox
						v-model="company.commercialDistinction.commercialName.active"
						button
						button-variant="primary"
						size="lg">
							Nom commercial
						</b-form-checkbox>

						<b-form-group invalid-feedback="Le nom commercial est obligatoire" class="mt-3" v-if="company.commercialDistinction.commercialName.active">
							<b-input
							v-model.trim="$v.company.commercialDistinction.commercialName.text.$model"
							:state="validateState($v.company.commercialDistinction.commercialName.text)" />
						</b-form-group>
					</b-col>

					<b-col cols="12" md="4">
						<b-form-checkbox
						v-model="company.commercialDistinction.sign.active"
						button
						button-variant="primary"
						size="lg">
							Enseigne
						</b-form-checkbox>

						<b-form-group invalid-feedback="L'enseigne est obligatoire" class="mt-3" v-if="company.commercialDistinction.sign.active">
							<b-input
							v-model.trim="$v.company.commercialDistinction.sign.text.$model"
							:state="validateState($v.company.commercialDistinction.sign.text)" />
						</b-form-group>
					</b-col>
				</b-form-row>
			</b-form-group>
    </b-form>

		<OtherLegalFormModal :modalShow="modalShow" :type="'creation'" />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { mapGetters } from 'vuex'

  import axios from 'axios';

	import OtherLegalFormModal from '../OtherLegalFormModal.vue';

  import { required, numeric, minLength, maxLength } from "vuelidate/lib/validators";

  export default {
		components: {
			OtherLegalFormModal
		},
    props: ['clickedNext'],
    data() {
      return {
        title   : "<strong>Créez</strong> votre entreprise",
        modalShow: false,
        company : {
          name: null,
          activity  : null,
          legalForm: 'EURL / SARL',
          headOffice: {
            location: 'Au domicile du représentant légal',
            address: {
              name: null,
              place: null,
              zipCode: null,
              city: null
            }
          },
          socialObject: null,
          shareCapital: {
            type: 'Fixe',
						liberation: "100% libéré",
            deposit: {
              location: 'Dans une banque',
              name: null,
              address: {
                place: null,
                zipCode: null,
                city: null
              }
            }
          },
          fiscalYear: {
            dateOfFirst: "1er janvier",
            closingDate: "31 décembre",
            closingDateOfFirst: "2021"
          },
          commercialDistinction: {
            acronym: {
              active: false,
              text: null
            },
            commercialName: {
              active: false,
              text: null
            },
            sign: {
              active: false,
              text: null
            }
          }
        },
        headOffice : {
          locations : [
            { text: 'Au domicile du représentant légal', value: "Au domicile du représentant légal" },
            { text: 'Domiciliation via Assistel', value: "Domiciliation via Assistel" },
            { text: 'Domiciliation via une autre entreprise', value: "Domiciliation via une autre entreprise" },
            { text: 'Dans des locaux que vous louez', value: "Dans des locaux que vous louez" },
            { text: 'Autre (pépinière, incubateur, etc.)', value: "Autre (pépinière, incubateur, etc.)" },
          ]
        },
        shareCapitalDeposits: [
					{ text: 'Dans une banque', value: 'Dans une banque' },
					{ text: 'Autre (Étude notariale ou Caisse des Dépôts', value: 'Autre (Étude notariale ou Caisse des Dépôts' }
				],
				citiesList: [],
        firstFiscalYearsDates: [
          "1er janvier",
          "1er avril",
          "1er juillet",
          "1er octobre"
        ],
        fiscalYearEndDates: [
          "31 décembre",
          "31 mars",
          "30 juin",
          "30 septembre"
        ],
        fiscalEndYears: [
          new Date().getFullYear(),
          new Date().getFullYear() + 1
        ]
      }
    },
    validations() {
      let datas = {
        company : {
          name: { required },
          activity: { required },
          socialObject: { required },
          shareCapital: {
            deposit: {
              name: { required },
              address: {
                place: { required },
                zipCode: {
                  required,
                  numeric,
                  minLength: minLength(5),
                  maxLength: maxLength(5)
                },
                city: { required }
              }
            }
          },
          fiscalYear: {
            dateOfFirst: { required },
            closingDate: { required },
            closingDateOfFirst: { required }
          }
        }
      }

      if (this.company.headOffice.location === "Domiciliation via Assistel") {
        datas.company.headOffice = {
          address: {
            name: { required }
          }
        }
      } else {
        datas.company.headOffice = {
          address: {
            place: { required },
            zipCode: {
              required,
              numeric,
              minLength: minLength(5),
              maxLength: maxLength(5)
            },
            city: { required }
          }
        }
      }

      if (this.company.commercialDistinction.acronym.active || this.company.commercialDistinction.commercialName.active || this.company.commercialDistinction.sign.active) {
        datas.company.commercialDistinction = {};

        if (this.company.commercialDistinction.acronym.active) {
          datas.company.commercialDistinction.acronym = {
						text: { required }
          }
        }

        if (this.company.commercialDistinction.commercialName.active) {
          datas.company.commercialDistinction.commercialName = {
						text: { required }
          }
        }

        if (this.company.commercialDistinction.sign.active) {
          datas.company.commercialDistinction.sign = {
						text: { required }
          }
        }
      }

      return datas;
    },
    watch: {
      $v: {
        handler (val) {
          this.$store.commit('updateCreationCompany', { company: this.company });

          /* let salesAgentQuality = (this.company.legalForm !== "SAS" && this.company.legalForm !== "SASU") ? "Dirigeant" : "Président";
          this.$store.commit('updateCreationSalesAgentQuality', { salesAgentQuality : salesAgentQuality }) */

          if (!val.$invalid) {
            this.$emit('can-continue', { value: true });
          } else {
            this.$emit('can-continue', { value: false });
          }
        },
        deep: true
      },
      clickedNext () {
        this.$v.$touch();
      }
    },
    methods: {
			addDomiciliationFees (event) {
				this.$store.commit('addDomiciliationFees', event);
			},
      getCitiesByZipCode (zipCode) {
        if (zipCode.length === 5) {
          let requestTarget = this.apiDomain + '/get-cities-by-zip-code';

          axios.post(requestTarget, {
            zipCode : zipCode
          })
          .then((response) => {
            let citiesByZipCode = response.data.citiesByZipCode;
            let cities = [];

            citiesByZipCode.forEach((city) => {
              cities.push(city.nomCommune)
            });

            this.citiesList = cities;
          });
        }
      },
      setFirstFiscalYear () {
        this.fiscalYearEndDates.forEach( (fiscalYearEndDate, index) => {
          if (this.company.fiscalYear.closingDate === fiscalYearEndDate) {
            this.company.fiscalYear.dateOfFirst = this.firstFiscalYearsDates[index];
          }
        });
      },
      validateState (v) {
        if (!v.$dirty) {
          return null;
        } else {
          return (v.$error) ? false : true
        }
      },
      legalFormChange (event) {
				this.modalShow = (event === 'Autre' || event === 'Auto-Entrepreneur / Micro-Entreprise') ? true : false

				if (event === 'EURL / SARL') {
					this.shareCapital.types.push({ text: '20% libéré', value: '20% libéré' })
				} else if (event === 'SAS' || event === 'SASU') {
					this.shareCapital.types.push({ text: '100% libéré', value: '100% libéré' })
				}
      }
    },
    computed: {
			...mapState(['appName', 'assistant', 'apiDomain', 'legalForms']),
			...mapGetters(['getDomiciliationAddresses'])
    },
    mounted() {
      this.company.headOffice.address.name = this.getDomiciliationAddresses[0].value;
    }
  }
</script>
